import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { SiInstagram } from '@react-icons/all-files/si/SiInstagram';
import { FaTwitter } from '@react-icons/all-files/fa/FaTwitter';
import { GrYoutube } from '@react-icons/all-files/gr/GrYoutube';

const Footer = () => {
    return (
        <div className='footer'>
            <div className="footer-inner">
                <Container fluid>
                    <Row>
                        <Col md={7} lg={8} xl={9}>
                            <h2>TaleTree Inc.</h2>
                        </Col>
                        <Col md={5} lg={4} xl={3}>
                            <div className='footer-navs'>
                                <div className='footer-navs-col'>

                                    <h4>Company</h4>
                                    <ul>
                                        <li><a href='#'>Our Story</a></li>
                                        <li><a href='#'>TaleTree Friends</a></li>
                                        <li><a href='#'>Blog</a></li>
                                        <li><a href='#'>Contact</a></li>
                                        <li><a href='#'>Partners</a></li>
                                    </ul>
                                </div>
                                <div className='footer-navs-col'>
                                    <h4>Support</h4>
                                    <ul>
                                        <li><a href='#'>Terms of Service</a></li>
                                        <li><a href='#'>Privacy Policy</a></li>
                                        <li><a href='#'>TaleTree Pledge</a></li>
                                        <li><a href='#'>Email Us</a></li>
                                    </ul>
                                </div>
                            </div>
                        </Col>
                    </Row>

                </Container>
            </div>
            <div className="footer-bottom">
                <Container fluid>
                    <Row className="align-items-center">
                        <Col sm={6}>
                            <div>© 2021 TaleTree Inc. All rights reserved</div>
                        </Col>
                        <Col sm={6}>
                            <ul>
                                <li><a href='#' title='Instagram'><SiInstagram /></a></li>
                                <li><a href='#' title='Twitter'><FaTwitter /></a></li>
                                <li><a href='#' title='Youtube'><GrYoutube /></a></li>
                            </ul>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default Footer;